import Http from "./http";

export const triggerWelcomeCampaignAPI = (payload) => {
  return Http.post("admin/campaign/trigger-welcome", payload);
};
